import request from "@/utils/request";

export function getGrcDashboardAnalytics(params) {
  return request({
    url: "/grc-dashboard/analytics",
    method: "get",
    params,
  });
}
